import { ExtProperties } from './ext-properties.model';
export class ItemsModel {
    action: string;
    employeeClientId: string;
    serviceClientId: string;
    extProperties: ExtProperties;

    constructor() {
        this.action = undefined;
        this.employeeClientId = undefined;
        this.serviceClientId = undefined;
    }
}
